import { ROUTE_PATHS } from '@/config/routes'
import { writeResidentListSessionFilter } from '@/features/resident/utils/residentSessionFilter'
import { saveReimbursementFiltersToSession } from '@/features/reimbursements/utils/sessionFilterStorage'
import type { ReimbursementFilters } from '@/features/reimbursements/types'

export function buildReactResidentListPathForApplicant(
  applicantId: string | number,
): string {
  const q = new URLSearchParams()
  q.set('applicant_id', String(applicantId))
  q.set('past_customer', '1')
  return `${ROUTE_PATHS.DASHBOARD_RESIDENTS}?${q.toString()}`
}

export function buildReactReimbursementsListPathForApplicant(
  applicantId: string | number,
): string {
  const q = new URLSearchParams()
  q.set('applicant_id', String(applicantId))
  q.set('past_customer', '1')
  return `${ROUTE_PATHS.DEFAULTS}?${q.toString()}`
}

/**
 * Angular `showResidentDefault(1)` session write:
 * `{ past_customer: '1', q: applicantId }` → `residentlist_filter`.
 */
export function writeApplicationResidentListHandoff(applicantId: string | number): void {
  writeResidentListSessionFilter({
    past_customer: '1',
    q: String(applicantId),
  })
}

/**
 * Angular `showResidentDefault(2)` session write for the reimbursements list.
 * Mirrors `{ past_customer: '1', q: applicantId }` on `defaultlist_filter`.
 */
export function writeApplicationReimbursementsListHandoff(
  applicantId: string | number,
): void {
  saveReimbursementFiltersToSession({
    past_customer: '1',
    q: String(applicantId),
    page: 1,
  } as ReimbursementFilters)
}

export function getResidentListUrlForApplicant(applicantId: string | number): string {
  return buildReactResidentListPathForApplicant(applicantId)
}

export function getReimbursementsListUrlForApplicant(
  applicantId: string | number,
): string {
  return buildReactReimbursementsListPathForApplicant(applicantId)
}

/** Angular `showResidentDefault(1)` — resident list filtered by applicant in a new tab. */
export function openResidentListForApplicant(applicantId: string | number): void {
  // `noopener` new tabs do not inherit sessionStorage — the URL `applicant_id`
  // query is the reliable handoff; the session write only helps the current tab.
  writeApplicationResidentListHandoff(applicantId)
  window.open(getResidentListUrlForApplicant(applicantId), '_blank', 'noopener,noreferrer')
}

/** Angular `showResidentDefault(2)` — reimbursements list filtered by applicant in a new tab. */
export function openReimbursementsListForApplicant(applicantId: string | number): void {
  writeApplicationReimbursementsListHandoff(applicantId)
  window.open(
    getReimbursementsListUrlForApplicant(applicantId),
    '_blank',
    'noopener,noreferrer',
  )
}
